export default [
    {
        path: 'permissao',
        component: () => import(
            /* webpackChunkName: 'administracao-permissao' */
            '@/views/administracao/permissao/Index'
        ),
        redirect: 'permissao/index',
        children: [
            {
                name: 'administracao-permissao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'administracao-permissao' */
                    '@/views/administracao/permissao/List.vue'
                ),
            },
            {
                name: 'administracao-permissao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'administracao-permissao' */
                    '@/views/administracao/permissao/Form.vue'
                ),
            },
        ],
    },
]